import { Component, Input } from '@angular/core';
import { Entity } from '@model/entities/entity';
import { ScrollService } from '@service/scroll.service';
import moment from 'moment';
import { EntityTypeConfig } from '@model/entity-type-config';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { HelperService } from '@service/helper.service';
import { instanceOfLikeable, Likeable } from '@interface/likeable';
import { ProfileTypeIdentifier } from '@enum/profile-type-identifier';
import { UserService } from '@service/user/user.service';
import { CategoriesService } from '@service/categories.service';
import { StateService } from '@service/state.service';
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service';

@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
})
export class ContentPreviewComponent {
  public moment = moment;

  @Input()
  public get entity() {
    return this._entity;
  }
  public set entity(e: Entity) {
    this._entity = e;

    if (instanceOfLikeable(e)) this.likeable = e as Likeable;
  }
  public _entity: Entity = null;

  public likeable: Likeable = null;

  @Input()
  public mode: 'bookmark' | 'edit' = null;

  @Input()
  public delete: (entity: Entity) => void;

  @Input()
  public removeFav: (entity: Entity) => void;

  public ProfileTypeIdentifier = ProfileTypeIdentifier;

  constructor(
    private scrollService: ScrollService,
    private entityTypeConfigService: EntityTypeConfigService,
    public helperService: HelperService,
    public UserService: UserService,
    public CategoriesService: CategoriesService,
    private StateService: StateService,
  ) {}

  public edit() {
    let config: EntityTypeConfig = this.entityTypeConfigService.getConfigByEntity(this.entity);

    this.StateService.goto(config.editstate + '/' + this.entity.id).then(() => {
      this.scrollService.scrollToTop();
    });
  }

  public goToDetail() {
    let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByEntity(this.entity);

    this.StateService.goto(
      entityTypeConfig.detailstate + '/' + this.entity.id + '/' + UrlPrettifierService.prettyUrl(this.entity.title),
    ).then(() => {
      this.scrollService.scrollToTop();
    });
  }
}
